export const text = {
  Save: "Save",
  Yes: "Yes",
  No: "No",
  Cancel: "Cancel",
  Add: "Add",
  Actions: "Actions",
  Enddatemustbegreaterthanstartdate:
    "End date must be greater than start date.",
  Pleasefilloutallrequiredfields: "Please fill out all required fields.",
  Areyousureyouwanttodeletethis: "Are you sure you want to delete this ?",
  Id: "Id",
  Title: "Title",
  Status: "Status",
  Submit: "Submit",
  addedsuccessfully: "added successfully!",
  updatedsuccessfully: "updated successfully!",
  deletedsuccessfully: "deleted successfully!",
  cancelledsuccessfully: "cancelled successfully!",
  submittedsuccessfully: "submitted successfully!",
  Draft: "Draft",
  Submitted: "Submitted",
  Cancelled: "Cancelled",
  Delete: "Delete",
  Update: "Update",
  Areyousureyouwanttocancelthis: "Are you sure you want to cancel this",
  Areyousureyouwanttosubmitthis: "Are you sure you want to submit this",
  CreatedAt: "Created At",
  Owner: "Owner",
  Areyousureyouwanttologout: "Are you sure you want to logout?",
  NoDataFound: "No Data Found",
  SubmittedBy: "Submitted By",
  SubmittedOn: "Submitted On",
  Completed: "Completed",
  Pending: "Pending",
  Overdue: "Overdue",
  Submitted: "Submitted",
  Rejected: "Rejected",
  Approved: "Approved",
  Poll: "Poll",
  Subjective: "Subjective",
  Objective: "Objective",
  Documentation: "Documentation",
  Video: "Video",
  Quiz: "Quiz",
  Image: "Image",
  Monday: "Monday",
  Tuesday: "Tuesday",
  Wednesday: "Wednesday",
  Thursday: "Thursday",
  Friday: "Friday",
  Saturday: "Saturday",
  Sunday: "Sunday",
  Male: "Male",
  Female: "Female",
  Other: "Other",
  "Onboarding Task": "Onboarding Task",
  in_progress: "In Progress",
  completed: "Completed",
  Somethingwentwrong: "Something went wrong",
  DataNotFound: "Data Not Found",
  Time: "Time",
  DateTime: "Date Time",
  TextInput: "Text Input",
  TextArea: "Textarea",
  multiplechoice: "Multiple Choice",
  Dropdown: "Dropdown",
  Checkboxes: "Checkboxes",
  Rating: "Rating",
  FileUpload: "File Upload",
  On: "On",
  Off: "Off",
  "place-holder-option-1": "Place holder option 1",
  "place-holder-option-2": "Place holder option 2",
  "place-holder-option-3": "Place holder option 3",
  SeeMore: "See More",
  notifications: "Notifications",
  NoNotifications: "No Notifications",
};
